import React from 'react';
import { styled } from '@mui/system';
import eventFormatter from '#component/device/event-formatter';
import eventIcon from '#component/icon/event';

const EventContainer = styled('div')(() => ({
  display: 'flex',
  minWidth: '150px'
}));

const EventIcon = styled('div')(({ theme }) => ({
  color: 'grey',
  alignSelf: 'center',
  marginRight: theme.spacing()
}));

const TooltipDescription = styled('div')(({ theme }) => ({
  '& p': {
    color: theme.palette.common.white
  }
}));
const defaultLastEvent = {
  details: '',
  description: 'Device was switched on',
  identifier: 'on',
  timestamp: '2020-07-16T11:51:17.000Z'
};

function DashboardEvent(props) {
  const {
    device: { lastEvent = {} },
    account,
    loading,
    showInTooltip,
    align
  } = props;

  const textAlign = align === 'end' ? 'end' : 'inherit';

  const EventContent = showInTooltip ? TooltipDescription : 'div';

  return (
    <EventContainer style={{ textAlign }}>
      <EventIcon>
        {lastEvent.identifier && eventIcon(lastEvent)}
      </EventIcon>
      <EventContent>
        {loading ?
          eventFormatter(defaultLastEvent, account) :
          (lastEvent.identifier ? eventFormatter(lastEvent, account) : null)}
      </EventContent>
    </EventContainer>
  );
}

export default DashboardEvent;
